
export class Logger  {
    constructor(isEnabled: boolean, addStackToInfo: boolean) {
        this.isEnabled = isEnabled;
        this.isAddStackToInfo = addStackToInfo;
    }

    public isEnabled: boolean = false;
    public isAddStackToInfo: boolean = false;

    public debug(obj:any) {
        if (this.isEnabled) {
            console.log(obj);
        }
    }

    public err(obj:any) {
        if (this.isEnabled) {
            console.error("ERROR: " + obj);
        }
    }

    public info(obj:any) {
        if (this.isEnabled) {
            if (this.isAddStackToInfo) {
                console.trace("INFO: " + obj);
            }
            else {
                console.log("INFO: " + obj);
            }
        }
    }
}

export default Logger;